import type { ReactElement } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import { getCrmName } from "app/pages/sales-intelligence/utils/crm";

import type { ITopCompanyAssociatedList } from "../../types/TopCompany";
import { TopCompanyAssociatedListType } from "../../types/TopCompany";

import {
    StyledTopCompanyListIconWrapper,
    StyledTopCompanyListLinkWrapper,
    StyledTopCompanyListNameWrapper,
} from "./styles";

type Props = {
    associatedList: ITopCompanyAssociatedList;
};

const TopCompanyAssociatedListLink = ({ associatedList }: Props): ReactElement => {
    const { id, name, assetType, crmIntegrationType, crmObjectType } = associatedList;
    const listName = crmIntegrationType ? getCrmName(crmIntegrationType) : name;

    const getListLink = (): string => {
        if (crmIntegrationType || crmObjectType) {
            if (!crmIntegrationType || !crmObjectType) {
                return "";
            }

            return siNavigator.createCrmListLink({
                crm: crmIntegrationType,
                objectType: crmObjectType,
            });
        }

        if (assetType === TopCompanyAssociatedListType.SavedSearch) {
            return siNavigator.createSavedSearchLink({ savedSearchId: id });
        }

        return siNavigator.createStaticListLink({ id });
    };

    const ListNameElement = crmIntegrationType ? (
        <Flex gap="4px">
            {crmIntegrationType ? (
                <StyledTopCompanyListIconWrapper>
                    <SWReactIcons
                        size="xs"
                        iconName={crmIntegrationType}
                        iconColor={colorsPalettes.carbon[200]}
                    />
                </StyledTopCompanyListIconWrapper>
            ) : null}
            <span>{listName}</span>
        </Flex>
    ) : (
        listName
    );

    return (
        <Flex
            gap="4px"
            maxWidth="100%"
        >
            <Text
                fontVariant="listItem3"
                color={colorsPalettes.carbon[250]}
            >
                <span>{translate("si.common.capitalized-in")}</span>
            </Text>
            <StyledTopCompanyListLinkWrapper>
                <a
                    href={getListLink()}
                    target="_blank"
                >
                    <StyledTopCompanyListNameWrapper
                        fontVariant="listItem3"
                        color={colorsPalettes.carbon[250]}
                    >
                        {ListNameElement}
                    </StyledTopCompanyListNameWrapper>
                </a>
            </StyledTopCompanyListLinkWrapper>
        </Flex>
    );
};

export default TopCompanyAssociatedListLink;
